// /web/src/components/PublicLayout.jsx
import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { ConsentProvider, useConsent } from "../consent/ConsentContext";
import CookieBanner from "../consent/CookieBanner";
import CookieSettingsModal from "../consent/CookieSettingsModal";
import SiteHeader from "./SiteHeader.jsx";

const navLinks = [
  { to: "/benefits", label: "Benefits" },
  { to: "/how-to", label: "How-to" },
  { to: "/blog", label: "Blog" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact us" }
];

function PublicFooter() {
  const { showSettings } = useConsent();

  return (
    <footer className="pd-footer" id="contact">
      <div className="pd-container pd-footer__inner">
        <p className="pd-muted">© Atlas of Change {new Date().getFullYear()}</p>
        <nav className="pd-footer__nav" aria-label="Footer">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Use</Link>
          <Link to="/contact">Contact us</Link>
          <Link to="/cookies">Cookie Policy</Link>
          <button
            type="button"
            className="pd-footer__nav-button"
            onClick={showSettings}
          >
            Cookie settings
          </button>
        </nav>
      </div>
    </footer>
  );
}

export default function PublicLayout() {
  const { isAuthenticated, loginWithRedirect, logout, isLoading } = useAuth0();

  const handleLogout = () => logout({ logoutParams: { returnTo: window.location.origin } });
  const handleLogin = () => loginWithRedirect();
  const handleSignup = () => loginWithRedirect({ authorizationParams: { screen_hint: "signup" } });

  return (
    <ConsentProvider>
      <div className="pd-root">
        <SiteHeader
          navLinks={navLinks}
          isAuthenticated={isAuthenticated}
          isLoading={isLoading}
          onLogin={handleLogin}
          onLogout={handleLogout}
          onSignup={handleSignup}
        />
        <main>
          <Outlet />
        </main>
        <PublicFooter />
      </div>
      <CookieBanner />
      <CookieSettingsModal />
    </ConsentProvider>
  );
}
